import React from 'react';
import styles from './ProgramCode.module.scss';

const ProgramCode = ({ programCode }) => {
    return (
        <td className={styles.cell}>
            <span className={styles.programCode}>{programCode}</span>
        </td>
    );
};

export default ProgramCode;
